
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design/[designId]",
      function () {
        return require("private-next-pages/design/[designId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design/[designId]"])
      });
    }
  